import {condition, request} from "../../../res/rest/restRequest";
import {api} from "../../../res/rest/api";
import {env} from "../../../res/config/env";
import HttpClient from "../../services/http/HttpClient";

const getOrderChargesRequest = async (session, orderID) => {

    const req = request.model(api.MODEL.C_ORDER_LINE)
        .select("C_OrderLine_ID","m_product_ID","m_attributeSetInstance_ID",
            "c_uom_ID","qtyEntered","LineNetAmt", "isBackOrder", "c_charge_ID")
        .expand("m_attributeSetInstance_ID")
        .expand("C_Charge_ID")
        .filter(condition.eq("C_Order_ID", orderID))
        .filter(condition.greaterThan("C_Charge_ID", 0))
        .buildRequest(env.API_URL);

    const resp = await HttpClient.client.get(req, api.auth(session))
    const charges = { byID: {}, lines: resp.data.records };
    for(const line of resp.data.records) {
        charges.byID[line.id] = line;
    }
    return charges;
}

export default getOrderChargesRequest;